var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.49 29H1.6A1.6 1.6 0 010 27.4V1.6A1.6 1.6 0 011.6 0h25.8A1.6 1.6 0 0129 1.6v25.8a1.6 1.6 0 01-1.6 1.6h-7.39V17.77h3.77l.564-4.377H20.01v-2.794c0-1.267.351-2.131 2.169-2.131l2.317-.001V4.552c-.4-.053-1.776-.172-3.377-.172-3.342 0-5.63 2.04-5.63 5.785v3.228h-3.778v4.377h3.779z",
    fill: "#4460a0"
  })));
}

export default SvgFacebook;